// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/deployer/v2/endpoint.proto (package ai.h2o.mlops.deployer.v2, syntax proto3)
/* eslint-disable */

import { getNameParser } from "../../../../../runtime";

/**
 * An endpoint which exposes a target resource.
 *
 * @generated from message ai.h2o.mlops.deployer.v2.Endpoint
 */
export type Endpoint = {
/**
 * The resource name of the endpoint, in the form:
 * "workspaces/{workspace}/endpoints/{endpoint}"
 *
 * @generated from field: string name = 1;
 */
name?: string;
/**
 * The human-readable name of this endpoint.
 *
 * @generated from field: string display_name = 2;
 */
displayName?: string;
/**
 * The description of this endpoint.
 *
 * @generated from field: string description = 3;
 */
description?: string;
/**
 * Required. The URI path for this endpoint. This must be in path-noscheme form without
 * the leading, ending and multiple consecutive "/" (see https://datatracker.ietf.org/doc/html/rfc3986#appendix-A).
 *
 * @generated from field: string path = 4;
 */
path: string;
/**
 * The target resource this endpoint is attached to. Example form:
 * "workspaces/{workspace}/deployments/{deploymentId}"
 *
 * If left out or empty, the endpoint is considered detached.
 *
 * @generated from field: string target = 5;
 */
target?: string;
/**
 * Output only. The time the endpoint was created.
 *
 * @generated from field: google.protobuf.Timestamp create_time = 6;
 */
createTime?: string;
/**
 * Output only. The time the endpoint was last updated.
 *
 * @generated from field: google.protobuf.Timestamp update_time = 7;
 */
updateTime?: string;
}
;
export const endpointName = getNameParser<'workspace' | 'endpoint'>("workspaces/{workspace}/endpoints/{endpoint}");
